 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-hi-json":"lang-hi-json","lang-mr-json":"lang-mr-json","view-About-vue":"view-About-vue","view-AttendanceQuiz-vue":"view-AttendanceQuiz-vue","view-BrowserCompatibility-vue":"view-BrowserCompatibility-vue","view-ChangePassword-vue":"view-ChangePassword-vue","view-Dashboard-vue":"view-Dashboard-vue","view-Dashboard1-vue":"view-Dashboard1-vue","view-Encryption-vue":"view-Encryption-vue","view-ForgotPassword-vue":"view-ForgotPassword-vue","view-Home-vue":"view-Home-vue","view-I18Demo-vue":"view-I18Demo-vue","view-IPDashboard-vue":"view-IPDashboard-vue","view-LearnerReport-vue":"view-LearnerReport-vue","view-Login-vue":"view-Login-vue","view-Login1-vue":"view-Login1-vue","view-Login2-vue":"view-Login2-vue","view-MQLRequestDemo-vue":"view-MQLRequestDemo-vue","view-MyDashboardTest-vue":"view-MyDashboardTest-vue","view-MyPlanForTheDay-vue":"view-MyPlanForTheDay-vue","view-Notification-vue":"view-Notification-vue","view-OtherReferences-vue":"view-OtherReferences-vue","view-Profile-vue":"view-Profile-vue","view-RatingAppraiser-vue":"view-RatingAppraiser-vue","view-Reflection-vue":"view-Reflection-vue","view-Registration-vue":"view-Registration-vue","view-ResetPassword-vue":"view-ResetPassword-vue","view-ResetPasswordLink-vue":"view-ResetPasswordLink-vue","view-Scrollbar-vue":"view-Scrollbar-vue","view-SelfRatingForMyWork-vue":"view-SelfRatingForMyWork-vue","view-Validator-vue":"view-Validator-vue","view-VueChartJS-vue":"view-VueChartJS-vue","view-Webcasts-vue":"view-Webcasts-vue"}[chunkId]||chunkId) + "." + {"lang-hi-json":"b0b04c4c","lang-mr-json":"0a2bc632","view-About-vue":"1c51a0f7","view-AttendanceQuiz-vue":"3a445a0a","view-BrowserCompatibility-vue":"8e370331","view-ChangePassword-vue":"fc2e30c9","view-Dashboard-vue":"1f60471a","view-Dashboard1-vue":"7d031cc5","view-Encryption-vue":"c65b3c03","view-ForgotPassword-vue":"35a67b49","view-Home-vue":"74edb920","view-I18Demo-vue":"c74a35f7","view-IPDashboard-vue":"09cf76be","view-LearnerReport-vue":"ff5d3e64","view-Login-vue":"7d8379e9","view-Login1-vue":"1f6ed32a","view-Login2-vue":"8f5bf636","view-MQLRequestDemo-vue":"78c56b8a","view-MyDashboardTest-vue":"44a740f9","view-MyPlanForTheDay-vue":"27c33f56","view-Notification-vue":"2869a184","view-OtherReferences-vue":"b83b2cd7","view-Profile-vue":"64b515d8","view-RatingAppraiser-vue":"128fa737","view-Reflection-vue":"b90f130a","view-Registration-vue":"b4c657e0","view-ResetPassword-vue":"cea72422","view-ResetPasswordLink-vue":"663643aa","view-Scrollbar-vue":"038aea49","view-SelfRatingForMyWork-vue":"cc27a0c4","view-Validator-vue":"0a6a2b6a","view-VueChartJS-vue":"23e2e2c4","view-Webcasts-vue":"dcedbedc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Dashboard-vue":1,"view-Dashboard1-vue":1,"view-ForgotPassword-vue":1,"view-Home-vue":1,"view-Login-vue":1,"view-Login1-vue":1,"view-Login2-vue":1,"view-MQLRequestDemo-vue":1,"view-ResetPasswordLink-vue":1,"view-VueChartJS-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-hi-json":"lang-hi-json","lang-mr-json":"lang-mr-json","view-About-vue":"view-About-vue","view-AttendanceQuiz-vue":"view-AttendanceQuiz-vue","view-BrowserCompatibility-vue":"view-BrowserCompatibility-vue","view-ChangePassword-vue":"view-ChangePassword-vue","view-Dashboard-vue":"view-Dashboard-vue","view-Dashboard1-vue":"view-Dashboard1-vue","view-Encryption-vue":"view-Encryption-vue","view-ForgotPassword-vue":"view-ForgotPassword-vue","view-Home-vue":"view-Home-vue","view-I18Demo-vue":"view-I18Demo-vue","view-IPDashboard-vue":"view-IPDashboard-vue","view-LearnerReport-vue":"view-LearnerReport-vue","view-Login-vue":"view-Login-vue","view-Login1-vue":"view-Login1-vue","view-Login2-vue":"view-Login2-vue","view-MQLRequestDemo-vue":"view-MQLRequestDemo-vue","view-MyDashboardTest-vue":"view-MyDashboardTest-vue","view-MyPlanForTheDay-vue":"view-MyPlanForTheDay-vue","view-Notification-vue":"view-Notification-vue","view-OtherReferences-vue":"view-OtherReferences-vue","view-Profile-vue":"view-Profile-vue","view-RatingAppraiser-vue":"view-RatingAppraiser-vue","view-Reflection-vue":"view-Reflection-vue","view-Registration-vue":"view-Registration-vue","view-ResetPassword-vue":"view-ResetPassword-vue","view-ResetPasswordLink-vue":"view-ResetPasswordLink-vue","view-Scrollbar-vue":"view-Scrollbar-vue","view-SelfRatingForMyWork-vue":"view-SelfRatingForMyWork-vue","view-Validator-vue":"view-Validator-vue","view-VueChartJS-vue":"view-VueChartJS-vue","view-Webcasts-vue":"view-Webcasts-vue"}[chunkId]||chunkId) + "." + {"lang-hi-json":"31d6cfe0","lang-mr-json":"31d6cfe0","view-About-vue":"31d6cfe0","view-AttendanceQuiz-vue":"31d6cfe0","view-BrowserCompatibility-vue":"31d6cfe0","view-ChangePassword-vue":"31d6cfe0","view-Dashboard-vue":"1a47a0d1","view-Dashboard1-vue":"447dc07b","view-Encryption-vue":"31d6cfe0","view-ForgotPassword-vue":"04dc0983","view-Home-vue":"a95df624","view-I18Demo-vue":"31d6cfe0","view-IPDashboard-vue":"31d6cfe0","view-LearnerReport-vue":"31d6cfe0","view-Login-vue":"0529b6ff","view-Login1-vue":"53828b6d","view-Login2-vue":"1fd3b376","view-MQLRequestDemo-vue":"d4abbd52","view-MyDashboardTest-vue":"31d6cfe0","view-MyPlanForTheDay-vue":"31d6cfe0","view-Notification-vue":"31d6cfe0","view-OtherReferences-vue":"31d6cfe0","view-Profile-vue":"31d6cfe0","view-RatingAppraiser-vue":"31d6cfe0","view-Reflection-vue":"31d6cfe0","view-Registration-vue":"31d6cfe0","view-ResetPassword-vue":"31d6cfe0","view-ResetPasswordLink-vue":"04dc0983","view-Scrollbar-vue":"31d6cfe0","view-SelfRatingForMyWork-vue":"31d6cfe0","view-Validator-vue":"31d6cfe0","view-VueChartJS-vue":"2d9fcc1a","view-Webcasts-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
